/* eslint-disable @typescript-eslint/no-magic-numbers */

import type CSSTypes from "./CSSTypes";

type Kernel = [number, number][];

const kernel = (...s: Kernel): Kernel =>
{
    const d = Math.max(...s.flat());

    s = s.map(([x, y]) => [x / d, y / d]);

    const rot = (x: boolean, y: boolean): Kernel =>
    {
        const xn = x? 1: -1;
        const yn = y? 1: -1;

        return s.map(([x, y]) => [x*xn, y*yn]);
    };

    return [
        ...rot(true, true),
        ...rot(true, false),
        ...rot(false, true),
        ...rot(false, false),
    ];
};

const kernels = {
    small: kernel([0, 2], [1, 2], [2, 1]),
    large: kernel([0, 3], [1, 3], [2, 2], [3, 1]),
};

export const textShadowOutline = (
    width: "xxs" | "xs" | "s" | "m" | "l" | "xl" | "xxl",
    color: CSSTypes["color"] | `#${string}` = "currentcolor",
) =>
{
    const spot = (k: Kernel, d: number) => k.map(([x, y]) => `${x/d}em ${y/d}em ${color}`);

    switch (width)
    {
        case "xxs": return spot(kernels.small, 24).join(", ");
        case "xs": return spot(kernels.small, 20).join(", ");
        case "s": return spot(kernels.small, 16).join(", ");
        case "m": return spot(kernels.small, 13).join(", ");
        case "l": return [...spot(kernels.small, 20), ...spot(kernels.large, 10)].join(", ");
        case "xl": return [...spot(kernels.small, 18), ...spot(kernels.large, 9)].join(", ");
        case "xxl": return [...spot(kernels.small, 16), ...spot(kernels.large, 8)].join(", ");
    }
};
